import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import PrivateRoute from '../../components/PrivateRoute'
import AdminRoute from '../../components/AdminRoute'

import {
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Alert,
  LinearProgress,
  Box
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { getSong, editSong } from '../../actions/songActions'

const EditSong = () => {
  const [formData, setFormData] = useState({
    title: '',
    link: '',
    body: ''
  })

  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { song, error, loading } = useSelector(state => state.songState)

  useEffect(() => {
    if (song) {
      setFormData({ title: song.title, link: song.link, body: song.body })
    }
  }, [song])

  useEffect(() => {
    dispatch(getSong(id))
  }, [])

  const changeField = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  const submitHandler = e => {
    e.preventDefault()
    dispatch(editSong(id, formData.title, formData.link, formData.body, navigate))
  }

  return (
    <PrivateRoute>
      <AdminRoute>
        <Card sx={{ maxWidth: 650, mt: 5, mx: 'auto' }}>
          {loading && <LinearProgress />}
          <CardContent sx={{ p: 3 }}>
            <Typography gutterBottom variant='h6'>Edit Song</Typography>
            <Typography color='textSecondary' gutterBottom>Leave blank to keep the same</Typography>
            {error && <Alert severity='error'>{error}</Alert>}
            {!song && <Alert severity='error'>This song doesn't exist</Alert>}
            <form onSubmit={submitHandler}>
              <TextField
                label='Title'
                fullWidth
                sx={{ my: 2 }}
                name='title'
                disabled={!song}
                value={formData.title}
                onChange={changeField}
              />
              <TextField
                label='External Link'
                fullWidth
                sx={{ my: 2 }}
                name='link'
                disabled={!song}
                value={formData.link}
                onChange={changeField}
              />
              <TextField
                label='Body'
                fullWidth
                sx={{ my: 2 }}
                name='body'
                maxRows={40}
                multiline
                disabled={!song}
                value={formData.body}
                onChange={changeField}
              />
              <Button variant='contained' type='submit' fullWidth sx={{ mt: 1 }} disabled={!song}>Submit</Button>
            </form>
          </CardContent>
        </Card>
      </AdminRoute>
    </PrivateRoute>
  )
}

export default EditSong